import { createStore } from "vuex";
import { Auth } from "app/auth/Auth";
import { SET_IS_OVERLAY_VISIBLE, SET_JWT_TOKEN } from "./AppStoreMutations";
export const appStore = createStore({
    state: {
        isOverlayVisible: false,
        jwtToken: Auth.getJwtToken()
    },
    mutations: {
        [SET_IS_OVERLAY_VISIBLE]: function (state, isOverlayActive) {
            state.isOverlayVisible = isOverlayActive;
        },
        [SET_JWT_TOKEN]: function (state, token) {
            Auth.setJwtToken(token);
            state.jwtToken = token;
        }
    },
    getters: {
        getIsOverlayVisible: function (state) {
            return state.isOverlayVisible;
        },
        getIsAuthenticated: function (state) {
            const token = state.jwtToken;
            return Auth.isValidJwtToken(token);
        },
        getEmail: function (state) {
            const token = state.jwtToken;
            return Auth.getEmail(token);
        },
        getUserId: function (state) {
            const token = state.jwtToken;
            return Auth.getUserId(token);
        },
        getIsSubscriptionActive: function (state) {
            const token = state.jwtToken;
            return Auth.isSubscriptionActive(token);
        },
        getJwtToken: function (state) {
            return state.jwtToken;
        }
    }
});
